var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"footer-main"}},[_c('b-container',{staticClass:"footer"},[_c('span',[_vm._v("IPH Sistemas - ©")]),_c('a',{attrs:{"href":"/files/politicas.pdf","download":""}},[_vm._v("Política de Privacidade")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }